(() => {
  const mapEl = document.getElementById("hreflang-url-map");
  if (!mapEl) return;

  let context = null;
  try {
    context = JSON.parse(mapEl.textContent);
  } catch (error) {
    return;
  }

  const countryToHreflang = {
    de: "de",
    uk: "en",
    fr: "fr",
    pl: "pl"
  };

  function normalizeSku(value) {
    return (value || "").toString().trim().toLowerCase();
  }

  function getUrlForCountry(urls, countryCode) {
    if (!urls || typeof urls !== "object") return null;
    const lower = (countryCode || "").toLowerCase();
    const upper = (countryCode || "").toUpperCase();
    const candidate = urls[lower] || urls[upper];
    return typeof candidate === "string" && candidate ? candidate : null;
  }

  function getCurrentSku() {
    if (context?.pageType !== "product") {
      return normalizeSku(context?.currentSku);
    }

    const variantSkuMap = context?.variantSkuMap;
    if (variantSkuMap && typeof variantSkuMap === "object") {
      const variantFromUrl = new URLSearchParams(window.location.search).get("variant");
      if (variantFromUrl && variantSkuMap[String(variantFromUrl)]) {
        return normalizeSku(variantSkuMap[String(variantFromUrl)]);
      }
    }

    return normalizeSku(context?.currentSku);
  }

  function getMappedUrl(countryCode) {
    const mappings = context?.urlMappings;
    if (!mappings) return null;

    if (context?.pageType === "product") {
      if (!Array.isArray(mappings)) return null;
      const sku = getCurrentSku();
      if (!sku) return null;

      const matched = mappings.find((item) => normalizeSku(item?.sku) === sku);
      return getUrlForCountry(matched?.urls, countryCode);
    }

    if (Array.isArray(mappings)) {
      const firstWithUrls = mappings.find((item) => item?.urls && typeof item.urls === "object");
      return getUrlForCountry(firstWithUrls?.urls, countryCode);
    }

    if (typeof mappings === "object" && mappings?.urls) {
      return getUrlForCountry(mappings.urls, countryCode);
    }

    return null;
  }

  let defaultHref = null;

  Object.entries(countryToHreflang).forEach(([countryCode, hreflang]) => {
    const link = document.querySelector(`link[rel="alternate"][hreflang="${hreflang}"]`);
    if (!link) return;

    const mappedUrl = getMappedUrl(countryCode);
    if (!mappedUrl) return;

    link.setAttribute("href", mappedUrl);
    if (countryCode === "de") {
      defaultHref = mappedUrl;
    }
  });

  const defaultLink = document.querySelector('link[rel="alternate"][hreflang="x-default"]');
  if (defaultLink && defaultHref) {
    defaultLink.setAttribute("href", defaultHref);
  }
})();
